export const arrayToObjectById = (arr, idKey = 'id') =>
  arr.reduce(
    (acc, arrElement) => ({
      ...acc,
      [arrElement[idKey]]: arrElement,
    }),
    {}
  )
